import { render, staticRenderFns } from "./cardVirtualAssistant.vue?vue&type=template&id=cbb1a844"
import script from "./cardVirtualAssistant.vue?vue&type=script&lang=js"
export * from "./cardVirtualAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports